import { render, staticRenderFns } from "./OptionGroupTile.vue?vue&type=template&id=8f639998&"
import script from "./OptionGroupTile.vue?vue&type=script&lang=ts&"
export * from "./OptionGroupTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports